import { useContext } from "react";
import IconButton, { IconButtonThemes } from "../../../../components/Button/IconButton";
import { TrashIcon } from "../../../../components/Icons/TrashIcon";
import Tooltip from "../../../../components/Tooltip/Tooltip";
import { VideoEditorContext } from "../../../../App";
import { ButtonWrapper } from "./navbarActions.styles";

const DeleteTool = () => {
  const { handleDeleteCurrentObject } = useContext(VideoEditorContext);

  return (
    <ButtonWrapper>
      <IconButton
        iconButtonTheme={IconButtonThemes.Transparent}
        icon={<TrashIcon color="white" />}
        onClick={handleDeleteCurrentObject}
      />
      <Tooltip
        text={"Delete"}
        position="bottom"
        style={{ boxShadow: "none", borderRadius: "4px", padding: "4px 8px 6px" }}
        reverseColor
        arrow
      />
    </ButtonWrapper>
  );
};

export default DeleteTool;
